import {
  ActivityCardMapMedia,
  ActivityCardPrice,
  ActivityCardHeader,
  ActivityCardRating,
} from '@care/provider-react-components';
import { Box, Link, Stack } from '@mui/material';
import { seoActivitySegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_activitySearchResults_seoSegmentationActivity as SEOSegmentationActivity } from '@/__generated__/seoActivitySegmentationListingPage';
import {
  getActivityCardImages,
  getActivityCardProvider,
  getActivityCardRating,
  getActivityCardUrl,
} from '../helpers';

type ActivitiesInfoCardMobileProps = {
  activity: SEOSegmentationActivity;
  prevPrice?: number;
  price: number;
  slotProps?: { 'data-testid': string };
};

const ActivitiesInfoCardMobile = ({
  activity,
  prevPrice = undefined,
  price,
  slotProps,
}: ActivitiesInfoCardMobileProps) => {
  const url = getActivityCardUrl(activity);

  const renderCard = () => {
    const rating = getActivityCardRating(activity);
    const internalRating = typeof rating === 'number';

    const InternalRatingElement =
      internalRating && rating > 0 ? <ActivityCardRating rating={rating} /> : null;

    return (
      <Stack
        direction="row"
        sx={{
          width: '90%',
          overflow: 'hidden',
          backgroundColor: 'background.default',
          borderRadius: 4,
          position: 'absolute',
          bottom: 70,
          left: '50%',
          transform: 'translateX(-50%)',
        }}>
        <ActivityCardMapMedia
          imageUrl={getActivityCardImages(activity)[0]}
          sx={{ backgroundColor: 'background.default' }}
        />

        <Stack
          direction="column"
          flex={1}
          p={2}
          zIndex={110}
          sx={{ backgroundColor: 'background.default' }}>
          <ActivityCardHeader
            title={activity.title}
            variant="map"
            organizatorName={getActivityCardProvider(activity)}
          />
          <Stack mt={2.5} direction="row" justifyContent="space-between" alignItems="center">
            <ActivityCardPrice
              price={price === 0 ? undefined : price}
              prevPrice={prevPrice || undefined}
              statusText={price === 0 ? 'Check price' : undefined}
              statusTextSx={({ palette }) => ({
                textDecoration: 'underline',
                fontWeight: 400,
                color: palette.text.tertiary,
              })}
            />
            {internalRating ? InternalRatingElement : rating}
          </Stack>
        </Stack>
      </Stack>
    );
  };

  return url ? (
    <Link href={url} underline="none" variant="link2" color="care.black" {...slotProps}>
      {renderCard()}
    </Link>
  ) : (
    <Box {...slotProps}>{renderCard()}</Box>
  );
};

export { ActivitiesInfoCardMobile };
